var map = {
	"./driving_style_de_desktop.webm": "9ded",
	"./driving_style_en_desktop.webm": "3b33",
	"./location-service_de_desktop.webm": "acf1",
	"./location-service_en_desktop.webm": "3f78",
	"./operational-monitoring_de_desktop.webm": "2511",
	"./operational-monitoring_en_desktop.webm": "ce92",
	"./operational-planning_de_desktop.webm": "860c",
	"./operational-planning_en_desktop.webm": "9849",
	"./time-management_de_desktop.webm": "9912",
	"./time-management_en_desktop.webm": "09d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2565";